import {createSelector} from 'reselect';
import type {DesignerStores} from '@packages/systems/designer/flux';

/**
 * Merges server-persisted CMS RTF component IDs (from DesignerStore) with
 * live component IDs from all users' presences (cmsRtfComponentIdsInUse).
 *
 * This gives validation a complete picture of which components are used
 * in CMS Rich Text, including unsaved usage by other users.
 */
export const selectAllCmsRtfComponentIds = createSelector(
  (state: DesignerStores) => state?.DesignerStore?.cmsRtfComponentIds ?? [],
  (state: DesignerStores) => state?.MultiplayerPresenceStore?.presences,
  (serverIds, presences): readonly string[] => {
    if (!presences) return serverIds;

    const merged = new Set(serverIds);
    for (const presence of Object.values(presences)) {
      if (presence.cmsRtfComponentIdsInUse) {
        for (const id of presence.cmsRtfComponentIdsInUse) {
          merged.add(id);
        }
      }
    }

    if (merged.size === serverIds.length) return serverIds;
    return Array.from(merged);
  }
);
